define('modules/Cart/CartItemNotes',[
    'jquery',
    'lodash',
    'global/all',
    './CartItemNotesService'
], function ($, _, Roc, CartItemNotesService) {
    'use strict';

    var selectors = {
        'addItemNotesBtn': 'button.btnAction[data-roc-action="addUpdateItemNotes"]',
        'itemNotesTextArea': 'textarea.item-notes'
    };

    function updateItemNoteEvt() {
        Roc.UI.siteBody
            .off('click', selectors.addItemNotesBtn)
            .on('click', selectors.addItemNotesBtn, function (e) {
                var $modal = $(this).closest('.white-popup');
                var $textarea = $modal.find(selectors.itemNotesTextArea);
                var itemId = $textarea.attr('data-item-id');
                var originalNote = $textarea.attr('data-roc-original-value');
                var currentNote = $textarea.val();

                if (originalNote !== currentNote) {
                    Roc.Core.lockButton(e.target);
                    CartItemNotesService.updateItemNote(itemId, currentNote)
                        .complete(function (xhr) {
                            var response = xhr.responseJSON || {};
                            // trigger an event including the response (use the same type of event that's in the ROC base)
                            // CartItems module will do the rest (like error handling/displaying, refreshing front-end, etc.).
                            Roc.EventManager.notify(Roc.Events.cart.UPDATE_ITEM, response);
                            Roc.UI.Modal.close();
                        }).always(function() {
                            Roc.Core.releaseLockedButton(e.target);
                        });
                } else {
                    // nothing changed, closing the popup
                    Roc.UI.Modal.close();
                }
            });
    }
    
    function bindEvents() {
        updateItemNoteEvt();
    }

    function init() {
        bindEvents();
    }
    
    var CartItemNotes = {
        init: init
    };

    Roc.Logger.debug('CartItemNotes.js Loaded:', CartItemNotes);

    return CartItemNotes;
});

